import { fetch as wFetch } from 'whatwg-fetch';

function submitForm(evt) { //eslint-disable-line no-unused-vars

  evt.preventDefault();
  evt.stopPropagation();

  let finalfetch = window.fetch || wFetch;

  const form = document.getElementById('reset-form');
  const formdata = new FormData(form);

  let msg_elm = document.getElementById('messages');
  let err_con = document.getElementById('error-content');
  let info_con = document.getElementById('info-content');

  let err_msg = 'Der er desværre sket en fejl. Prøv igen senere og kontakt BiQ support hvis problemet fortsætter';

  // hacking for ie. formdata will be empty if we dont append a bogus field
  // -- note: unlike the sign in page this doubles as the edit pwd url to pass to the backend
  formdata.append('requester', location.origin+'/sign_in/edit');

  finalfetch('/reset_password', {
    method: 'POST',
    credentials: 'include',
    body: formdata
  }).then(function(response) {
    if (response.ok) return response.json();
    throw new Error(err_msg);
  }).then(function(result) {
    if (result.message) {
      info_con.innerText = result.message;
      err_con.style.display = 'none';
    } else {
      err_con.innerText = err_msg;
      info_con.style.display = 'none';
    }
    msg_elm.classList.add('expand');
  }).catch(function(err) {
    console.log(err); // eslint-disable-line
    err_con.innerText = err.message;
    info_con.style.display = 'none';
    msg_elm.classList.add('expand');
  });

  return false;
}

const form = document.getElementById('reset-form');

form.addEventListener('submit', submitForm);
